import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Modal } from "uiv";
import { ref } from "vue";
import InviteControl from "./invite-control.vue";
import { InviteControlApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewpoints-invite-dialog',
  setup(__props, { expose: __expose }) {

const resolveCallback = ref<(() => void) | null>(null);

const model = ref<InviteControlApiModel | null>(null);

const shown = ref(false);

function open(inviteModel: InviteControlApiModel): Promise<void> {
  model.value = inviteModel;
  shown.value = true;
  return new Promise((resolve) => {
    resolveCallback.value = resolve;
  });
}

function close(): void {
  shown.value = false;
  model.value = null;
  if (resolveCallback.value) {
    resolveCallback.value();
  }
}

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  return (model.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shown).value = $event)),
        title: "Send Viewpoints Invitations",
        footer: false,
        id: "viewpoints-invite-dialofg"
      }, {
        default: _withCtx(() => [
          _createVNode(InviteControl, {
            model: model.value,
            "show-examples": false
          }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})